"use client";
import { useEffect, useRef, useState } from "react";

const loadScriptDom = (scriptDom: HTMLScriptElement) => {
  if (scriptDom) {
    const head = document.head;
    if (head) {
      console.log(scriptDom, "scriptDom");
      head.appendChild(scriptDom);
    }
  }
};

const loadScriptText = (scriptText: string) => {
  if (scriptText && scriptText.trim()) {
    // 处理可能的匿名函数声明

    // 随机生成一个函数名
    const functionName = `__anonymous__${Math.random()
      .toString(36)
      .substring(2, 15)}`;

    const processedScript = scriptText.replace(
      /function\s*\(/g,
      `function ${functionName}(`
    );

    let scriptDom = document.createElement("script");
    scriptDom.type = "text/javascript";
    scriptDom.text = processedScript;
    loadScriptDom(scriptDom);
  }
};

const injectJs = (code: string, cb?: () => void) => {
  const tempDivDom = document.createElement("div");
  // 将字符串作为 HTML 插入到新的 div 中
  tempDivDom.innerHTML = code;
  // 遍历新 div 中的所有 script 元素
  Array.from(tempDivDom.getElementsByTagName("script")).forEach((script) => {
    // 如果该 script 元素有 src 属性，则动态引入外部 JavaScript
    if (script.src) {
      const newScript = document.createElement("script");
      for (let i = 0; i < script.attributes.length; i++) {
        const attr = script.attributes[i];
        newScript.setAttribute(attr.name, attr.value);
      }
      loadScriptDom(newScript);
    } else {
      // 否则，执行内联的 JavaScript 代码
      loadScriptText(script.innerHTML);
    }

    // 删除已加载的片段
    tempDivDom.removeChild(script);
  });
  // 将剩余未经 script 包裹的片段加载
  loadScriptText(tempDivDom.innerHTML);
};

interface Props {
  codeSnippet?: string;
  shouldRun: boolean;
}

export function CookiePolicy(props: { code?: string }) {
  const [load, setLoad] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setLoad(true);
    }
  }, []);

  return <CodeSnippet shouldRun={load} codeSnippet={props.code} />;
}

export function CodeSnippet(props: Props) {
  const { shouldRun = false, codeSnippet = "" } = props;

  const firstRun = useRef<boolean>(true);

  useEffect(() => {
    if (shouldRun && firstRun.current) {
      injectJs(codeSnippet || "");
      firstRun.current = false;
    }
  }, [codeSnippet, shouldRun]);

  return null;
}
